module.exports = __webpack_public_path__ + "img/footer-link-44.9d032c03.png";